export const ASYNC_FETCH = 'ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
export const ASYNC_FETCH_FAILURE = 'ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE = 'ASYNC_FETCH_INVALIDATE';
export const GET_ADDONS = 'GET_ADDONS';
export const ADDONS_RESPONSE_RECEIVED = 'ADDONS_RESPONSE_RECEIVED';
export const GET_ADDONS_AEM_SUCCESS = 'GET_ADDONS_AEM_SUCCESS';
export const ERR_OCCURED = 'ERR_OCCURED';
export const GET_ADDONS_AEM = 'GET_ADDONS';
export const FETCH_E911ADDRESS = 'FETCH_E911ADDRESS';
export const FETCH_E911ADDRESS_SUCCESS = 'FETCH_E911ADDRESS_SUCCESS';
export const GET_NPA_NXX = 'GET_NPA_NXX';
export const GET_NPA_NXX_SUCCESS = 'GET_NPA_NXX_SUCCESS';
export const GET_NPA_NXX_FAILURE = 'GET_NPA_NXX_FAILURE';
export const ASSIGN_MTN_STATUS = 'ASSIGN_MTN_STATUS';
export const ADD_YTTV_TO_CART = 'ADD_YTTV_TO_CART';
export const GET_PROMOS = 'GET_PROMOS';
export const PROMOS_RESPONSE_RECEIVED = 'PROMOS_RESPONSE_RECEIVED';
export const ASSIGN_MTNS = 'ASSIGN_MTNS';
export const GET_NPA_NXX_ON_HP = 'GET_NPA_NXX_ON_HP';
export const GET_ASSIGNMTN = 'GET_ASSIGNMTN';
export const NPA_CALL = 'NPA_CALL';
export const IS_NPA_CALL = 'IS_NPA_CALL';
export const HOME_LINE = 'HOME_LINE';
export const HOME_LINE_CALL = 'HOME_LINE_CALL';
export const UPDATE_MTN_STATUS = 'UPDATE_MTN_STATUS';
export const SKIP_STATUS = 'SKIP_STATUS';
export const SET_ADDONS = 'SET_ADDONS';
export const ASSIGN_ADDONS = 'ASSIGN_ADDONS';
export const ASSIGN_MTN_VALUES = 'ASSIGN_MTN_VALUES';
export const EMERGENCY_ADDRESS = 'EMERGENCY_ADDRESS';
export const VALIDATE_E911 = 'VALIDATE_E911';
export const VALIDATE_E911_RESPONSE = 'VALIDATE_E911_RESPONSE';
export const E911_RESPONSE = 'E911_RESPONSE';
export const ERORR_ADDON = 'ERORR_ADDON';
export const SHOW_ADD_NOTIFICATION = 'SHOW_ADD_NOTIFICATION';
export const UPDATE_PROCESS_STEP_ADDONS = 'UPDATE_PROCESS_STEP_ADDONS';
export const SET_SELECTED_PRODID = 'SET_SELECTED_PRODID';
export const SET_SELECTED_PRODNAME = 'SET_SELECTED_PRODNAME';
export const SET_ADDON_REFERENCE = 'SET_ADDON_REFERENCE';
export const SET_ADDON_COUNT = 'SET_ADDON_COUNT';
export const SHOW_ADDON_API_ERROR = 'SHOW_ADDON_API_ERROR';
export const ADDON_INVALIDCASE_ERROR = 'ADDON_INVALIDCASE_ERROR';
export const ADD_FEATURES_REMOVE_LOADED = 'ADD_FEATURES_REMOVE_LOADED';
export const ADD_ACCESSORY_REMOVE_LOADED = 'ADD_ACCESSORY_REMOVE_LOADED';
export const SHOW_SKIP_BTN = 'SHOW_SKIP_BTN';
export const CEF_ADDONS_API_ERROR = 'CEF_ADDONS_API_ERROR';
export const DEFAULT_ERROR_MESSAGE = 'Looks like something went wrong. Please try again later.';
export const GET_EXPRESS_CHECKOUT_DETAILS_IN_ADDONS = 'GET_EXPRESS_CHECKOUT_DETAILS_IN_ADDONS';

export const WHW_ACTIONS = {
  REDEEM: 'REDEEM',
  DOWNGRADE: 'DOWNGRADE',
  UPGRADE: 'UPGRADE',
};

export const DummyWHWPlus = [
  {
    whwServices: [
      {
        displayName: 'Whole-Home Wi-Fi Plus',
        disclaimerText: '',
        descriptionText: '24/7 tech support, plus two in&#45;home visits for your connected home products',
        learnMoreURL: '',
        skuDetails: {
          skuId: '3240',
          sorId: '3240',
          priceText: '5.0',
          discountPrice: '10.0',
          regularPrice: '15.0',
          featureType: 'SPO',
          routerSku: 'CE1000A',
          maxShip: '2',
          maxAllow: '3',
          categoryType: 'WHWPLUS',
        },
      },
    ],
  },
];
